<div class = "row my-row pt-5 pb-5">

    <div class="col-xl-12 my-col">
        <h1>{{ "SUPER-ADMIN.SIDE-MENU.PS-ADMIN" | translate }}</h1>
    </div>

    <div class='container-fluid my-container'>
        <div class='row my-row'>
            <div class='col-11 pb-5 my-col'>
                <div class='card'>
                    <div class='card-header'>
                        {{ "SUPER-ADMIN.PS.CARD-LIST-TITLE" | translate }}
                    </div>
                    <div class='card-body'>
                        <div class='container-fluid my-container'>
                            <app-error [error_message]="errorMessageListPS" [error_type]="errorTypeListPS"></app-error>

                            <div class="row my-row" *ngIf="users">
                                <div class="col-lg-12 my-col order-sm-last">
                                    <mat-form-field class="w-50">
                                        <input matInput #search (keyup)="applyFilter(search.value)" placeholder="{{ 'SUPER-ADMIN.PS.LIST.SEARCH' | translate }}">
                                    </mat-form-field>
                                    <button type="button" class="btn btn-primary mx-2" id="refreshTable" name="refreshTable" (click)="loadTabPs()">
                                        <em class="bi bi-arrow-clockwise"></em>
                                    </button>
                                </div>
                            </div>

                            <div *ngIf="users" class="table-container mat-elevation-z8">
                                <div class="example-table-container">
                                    <table mat-table id="users" class="exemple-table w-100" [dataSource]="users">
                    
                                        <ng-container matColumnDef="email">
                                            <th mat-header-cell *matHeaderCellDef class="pl-4 text-primary">
                                                <h6>{{ "SUPER-ADMIN.PS.LIST.EMAIL" | translate }}</h6>
                                            </th>
                                            <td mat-cell *matCellDef="let user" class="truncate-cell pl-4"
                                            data-toggle="tootip" data-placement="top" title="{{user.email}}">
                                                <p>{{user.email}}</p>
                                            </td>
                                        </ng-container>
                                        
                                        <ng-container matColumnDef="name">
                                            <th mat-header-cell *matHeaderCellDef class="pl-4 text-primary">
                                                <h6>{{ "SUPER-ADMIN.PS.LIST.DISPLAYNAME" | translate }}</h6>
                                            </th>
                                            <td mat-cell *matCellDef="let user" class="truncate-cell pl-4"
                                            data-toggle="tootip" data-placement="top" title="{{user.displayName}}">
                                                <p>{{ user.displayName }}</p>
                                            </td>
                                        </ng-container>
                    
                                        <ng-container matColumnDef="structure">
                                            <th mat-header-cell *matHeaderCellDef class="text-primary">
                                                <h6>{{ "SUPER-ADMIN.PS.LIST.CLIENTS" | translate }}</h6>
                                            </th>
                                            <td mat-cell *matCellDef="let user" class="truncate-cell px-1"
                                            data-toggle="tootip" data-placement="top" title="{{ getClients(user) }}">
                                                <p>{{ getClients(user) }}</p>
                                            </td>
                                        </ng-container>
                        
                                        <ng-container matColumnDef="actions">
                                            <th mat-header-cell *matHeaderCellDef class="text-center text-primary">
                                                <h6>{{ "SUPER-ADMIN.PS.LIST.ACTIONS" | translate }}</h6>
                                            </th>
                                            <td mat-cell *matCellDef="let user" style="text-align: center">  
                                                <button type="button" class="btn btn btn-success" 
                                                        data-toggle="tootip" data-placement="top" 
                                                        title="{{ 'SUPER-ADMIN.PS.LIST.BUTTONS.PASSWORD-RESET' | translate }}"
                                                        (click)="$event.stopPropagation();sendPasswordReset(user)">
                                                    <em class="bi bi-key"></em>
                                                </button>
                                                <button type="button" class="btn-warning btn ml-2"
                                                        data-toggle="tootip" data-placement="top"
                                                        title="{{ 'SUPER-ADMIN.PS.LIST.BUTTONS.EDIT-ACCOUNT' | translate }}" 
                                                        (click)="$event.stopPropagation();infoPS(user)">
                                                        <em class="bi bi-pencil"></em>
                                                </button>
                                            </td>
                                        </ng-container>
                    
                                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    
                                    </table>
                                </div>
                                <mat-paginator #paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
                            </div> 
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-11 pb-5 my-col">
                <div class="card">
                    <div class="card-header">
                        {{ "SUPER-ADMIN.PS.CARD-ADD-ONE-PS" | translate}}
                    </div>
                    <div class="card-body">
                        <app-ps-form [clients]="clients"></app-ps-form>
                    </div>
                </div>
            </div>

            <div class="col-11 pb-5 my-col">
                <div class="card">
                    <div class="card-header">
                        {{ "SUPER-ADMIN.PS.CARD-LOADPS" | translate}}
                    </div>
                    <div class="card-body">
                        <app-error [error_message]="errorMessageLoadPS" [error_type]="errorTypeLoadPS"></app-error>
                        <div class="row">
                            <div class="col-sm">
                                <div class="alert alert-success" role="alert">
                                    {{ "SUPER-ADMIN.PS.LOADPS.TEXT-INFO" | translate }} 
                                    <a class="link-info font-weight-bold" (click)="downloadLoadPS()">
                                        {{ "SUPER-ADMIN.PS.LOADPS.TEXT-INFO-LINK-LOADPS" | translate }}
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col-sm">
                                <input type="file" #uploadFileInput id="fileUpload" name="fileUpload" accept=".xlsx" (change)="fileUpdate()"/>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col-sm">
                                <button [disabled]="!fileUpload" type="button" class="btn btn-primary" (click)="loadPS(uploadFileInput)">
                                    {{ "BUTTONS.LOADPS" | translate }}
                                </button>
                            </div>
                        </div>
                        <div class="row mt-2" *ngIf="this.resSuccess.length > 0 || this.resError.length > 0">
                            <div class="col-sm" *ngIf="this.resSuccess.length > 0">
                                <h3>{{ "SUPER-ADMIN.PS.LOADPS.LIST-SUCCESS" | translate }}</h3>
                                <ul>
                                    <li *ngFor="let success of this.resSuccess">
                                        <p class="text-success">{{success}}</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="col-sm" *ngIf="this.resError.length > 0">
                                <h3>{{ "SUPER-ADMIN.PS.LOADPS.LIST-ERRORS" | translate }}</h3>
                                <ul>
                                    <li *ngFor="let error of this.resError">
                                        <p class="text-danger">{{error}}</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
